export function getContrastColor(hexColor) {
  if (!hexColor) return "black";
  const hex = hexColor.replace("#", "");
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);
  // Relative luminance formula https://en.wikipedia.org/wiki/Relative_luminance
  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance > 0.5 ? "black" : "white";
}
